import { render } from "./ServiceItem.vue?vue&type=template&id=11f55171&scoped=true"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"

import "./ServiceItem.vue?vue&type=style&index=0&id=11f55171&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f55171"]])

export default __exports__